import { c as _c } from "react/compiler-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { Dialog, Modal } from 'react-aria-components';
// next-intl's usePathname is locale-stripped: `/en-US/map/review` → `/map/review`. next/navigation's
// would give `/en-US/map/review`, and the `.replace('/map/', '')` below would yield `/en-USreview`,
// silently failing the `path !== 'review'` gate for en-US visitors.
import { usePathname } from '~/i18n/navigation';
import { usePlaygroundActions, usePlaygroundCurrentFullTrip, usePlaygroundCurrentSkeletonTrip, usePlaygroundDestinations, usePlaygroundSelectedDestinations, usePlaygroundUIState } from '~/stores/playgroundStore';
import type { StayTransformed } from '~/types/JourneyItem.types';
import { PlaceCard } from './PlaceCard';
import styles from './PlaceCardDialog.module.css';
export const PlaceCardDialog = () => {
  const $ = _c(34);
  const {
    dpPlaces
  } = usePlaygroundSelectedDestinations();
  const destinations = usePlaygroundDestinations();
  const {
    placeDialog
  } = usePlaygroundUIState();
  const {
    setPlaceDialog
  } = usePlaygroundActions();
  const fullTrip = usePlaygroundCurrentFullTrip();
  const skeletonTrip = usePlaygroundCurrentSkeletonTrip();
  const pathname = usePathname();
  let t0;
  if ($[0] !== pathname) {
    t0 = pathname?.replace("/map/", "");
    $[0] = pathname;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const path = t0;
  const trip = fullTrip ?? skeletonTrip;
  let t1;
  bb0: {
    if (!placeDialog || path !== "review" || !trip?.items) {
      t1 = null;
      break bb0;
    }
    let matches;
    if ($[2] !== placeDialog || $[3] !== trip.items) {
      matches = [];
      for (const item of trip.items) {
        if (item.type === "Stay" && item.title === placeDialog.placeName) {
          matches.push(item);
        }
      }
      $[2] = placeDialog;
      $[3] = trip.items;
      $[4] = matches;
    } else {
      matches = $[4];
    }
    t1 = matches;
  }
  const overviewItems = t1;
  if (!placeDialog) {
    return null;
  }
  const selectableDestinations = destinations.cmsDestinations.selectable.cmsPlaces;
  let t2;
  if ($[5] !== dpPlaces || $[6] !== placeDialog) {
    let t3;
    if ($[8] !== placeDialog) {
      t3 = place => place.id === placeDialog.placeId;
      $[8] = placeDialog;
      $[9] = t3;
    } else {
      t3 = $[9];
    }
    t2 = dpPlaces.some(t3);
    $[5] = dpPlaces;
    $[6] = placeDialog;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const isAdded = t2;
  let t3;
  if ($[10] !== placeDialog || $[11] !== selectableDestinations) {
    let t4;
    if ($[13] !== placeDialog) {
      t4 = place_0 => place_0.placeId === placeDialog.placeId;
      $[13] = placeDialog;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    t3 = selectableDestinations.some(t4);
    $[10] = placeDialog;
    $[11] = selectableDestinations;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  const isReachable = t3;
  const t4 = !!placeDialog;
  let t5;
  if ($[15] !== setPlaceDialog) {
    t5 = _val => {
      setPlaceDialog(null);
    };
    $[15] = setPlaceDialog;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const t6 = path === "review";
  let t7;
  if ($[17] !== t6) {
    t7 = clsx(styles.modal, {
      [styles.modalReview]: t6
    });
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== setPlaceDialog) {
    t8 = () => setPlaceDialog(null);
    $[19] = setPlaceDialog;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  const t9 = path === "review" ? "review" : "build";
  const t10 = overviewItems || undefined;
  const t11 = trip?.details?.startDate || undefined;
  let t12;
  if ($[21] !== isAdded || $[22] !== isReachable || $[23] !== placeDialog || $[24] !== t10 || $[25] !== t11 || $[26] !== t8 || $[27] !== t9) {
    t12 = <Dialog aria-label="place-modal"><PlaceCard isAdded={isAdded} isReachable={isReachable} place={placeDialog} close={t8} variant={t9} stayItems={t10} tripStartDate={t11} /></Dialog>;
    $[21] = isAdded;
    $[22] = isReachable;
    $[23] = placeDialog;
    $[24] = t10;
    $[25] = t11;
    $[26] = t8;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] !== t12 || $[30] !== t4 || $[31] !== t5 || $[32] !== t7) {
    t13 = <Modal isOpen={t4} onOpenChange={t5} isDismissable={true} className={t7}>{t12}</Modal>;
    $[29] = t12;
    $[30] = t4;
    $[31] = t5;
    $[32] = t7;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};